<section class="bg-gray-50 py-16 sm:py-18 md:py-24">
  <div class="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 sm:px-5 md:px-0 lg:grid-cols-24 lg:gap-10">
    <div class="lg:col-span-9 lg:col-start-2">
      <p class="text-sm font-semibold uppercase tracking-[0.2em] text-blue-700 font-['Inter']">O diferencial Casato</p>
      <h2 class="mt-3 text-gray-900 text-3xl font-extrabold font-['Inter'] leading-tight sm:mt-4 sm:text-4xl">
        Toda a análise de um imóvel numa tela só
      </h2>
      <p class="mt-4 text-base font-normal leading-relaxed text-gray-500 sm:mt-5 sm:text-lg sm:text-xl font-['Inter']">
        Outras plataformas mandam você direto pro site do leiloeiro. A Casato estrutura os dados que importam pra você não comprar uma dor de cabeça.
      </p>

      <ul class="mt-6 space-y-3 sm:mt-8 sm:space-y-4">
        <li class="flex items-start gap-3 text-sm font-normal leading-relaxed text-gray-500 font-['Inter'] sm:gap-4 sm:text-lg">
          <span class="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-green-50 text-green-600 sm:h-10 sm:w-10">
            <svg class="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5 12 4.7 4.5L19 7"/>
            </svg>
          </span>
          <span>Custos reais de aquisição, tributos e revenda</span>
        </li>
        <li class="flex items-start gap-3 text-sm font-normal leading-relaxed text-gray-500 font-['Inter'] sm:gap-4 sm:text-lg">
          <span class="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-green-50 text-green-600 sm:h-10 sm:w-10">
            <svg class="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5 12 4.7 4.5L19 7"/>
            </svg>
          </span>
          <span>Análise do entorno: serviços, mobilidade e valorização</span>
        </li>
        <li class="flex items-start gap-3 text-sm font-normal leading-relaxed text-gray-500 font-['Inter'] sm:gap-4 sm:text-lg">
          <span class="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-green-50 text-green-600 sm:h-10 sm:w-10">
            <svg class="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5 12 4.7 4.5L19 7"/>
            </svg>
          </span>
          <span>Validação de riscos: ocupação, dívidas e situação processual</span>
        </li>
      </ul>
    </div>

    <div class="lg:col-span-14 lg:col-start-11">
      <div class="overflow-hidden rounded-[1.5rem] border border-gray-200 bg-white shadow-[0px_12px_30px_rgba(15,23,42,0.08)] sm:rounded-[2rem] sm:shadow-[0px_16px_40px_rgba(15,23,42,0.10)]">
        <div class="flex items-center justify-between gap-4 border-b border-gray-200 px-4 py-3 sm:px-5 sm:py-4 md:px-7">
          <div class="flex items-center gap-2.5">
            <span class="h-3.5 w-3.5 rounded-full bg-gray-200 sm:h-4 sm:w-4"></span>
            <span class="h-3.5 w-3.5 rounded-full bg-gray-200 sm:h-4 sm:w-4"></span>
            <span class="h-3.5 w-3.5 rounded-full bg-gray-200 sm:h-4 sm:w-4"></span>
          </div>
          <p class="text-xs font-medium leading-tight text-gray-500 font-['Inter'] sm:text-sm sm:text-base">
            {{ selectedTab.headerTitle }}
          </p>
        </div>

        <div class="lg:hidden border-b border-gray-200 px-4 py-4 sm:px-5 md:px-7">
          <label for="analysis-tab-select" class="sr-only">Selecionar análise</label>
          <select
            id="analysis-tab-select"
            class="block w-full rounded-2xl border border-blue-100 bg-[#F7FAFF] px-4 py-3.5 text-sm font-semibold text-slate-700 shadow-[0px_1px_2px_-1px_rgba(37,99,235,0.10)] shadow-[0px_8px_20px_rgba(37,99,235,0.06)] focus:border-blue-400 focus:outline-none focus:ring-4 focus:ring-blue-100 font-['Inter']"
            [value]="selectedTabIndex"
            (change)="selectTabFromDropdown(($any($event.target)).value)">
            @for (tab of tabs; track tab.id; let index = $index) {
              <option [value]="index">{{ tab.label }}</option>
            }
          </select>
        </div>

        <div
          class="hidden grid-cols-2 border-b border-gray-200 lg:grid sm:grid-cols-4"
          role="tablist"
          aria-label="Painel de análise do imóvel">
          @for (tab of tabs; track tab.id; let index = $index) {
            <button
              [id]="'analysis-tab-' + index"
              type="button"
              role="tab"
              class="border-b-4 px-3 py-4 text-center text-xs font-semibold transition-colors focus:outline-none focus:ring-4 focus:ring-blue-100 sm:px-4 sm:py-5 sm:text-sm lg:text-[0.95rem]"
              [class.border-blue-600]="selectedTabIndex === index"
              [class.text-blue-600]="selectedTabIndex === index"
              [class.border-transparent]="selectedTabIndex !== index"
              [class.text-gray-500]="selectedTabIndex !== index"
              [attr.aria-selected]="selectedTabIndex === index"
              [attr.aria-controls]="'analysis-panel-' + index"
              [attr.tabindex]="selectedTabIndex === index ? 0 : -1"
              (click)="selectTab(index)"
              (keydown)="onTabKeydown($event, index)">
              {{ tab.label }}
            </button>
          }
        </div>

        <section
          [id]="'analysis-panel-' + selectedTabIndex"
          class="bg-white px-4 py-5 sm:px-5 sm:py-6 md:px-7 md:py-8"
          role="tabpanel"
          [attr.aria-labelledby]="'analysis-tab-' + selectedTabIndex">
          @if (selectedTab.id === 'simulacao-custos') {
            <h3 class="mb-5 text-xl font-extrabold leading-tight text-gray-900 font-['Inter'] sm:mb-6 sm:text-2xl">
              {{ selectedTab.contentTitle }}
            </h3>
          }

          @if (selectedTab.chips?.length) {
            <div class="mb-6 flex flex-wrap gap-2.5 sm:mb-8 sm:gap-3">
              @for (chip of selectedTab.chips; track chip.label) {
                <span class="inline-flex items-center rounded-xl bg-blue-50 px-3 py-2.5 text-xs font-semibold leading-tight text-blue-600 font-['Inter'] sm:px-4 sm:py-3 sm:text-sm sm:text-base">
                  {{ chip.label }}
                </span>
              }
            </div>
          }

          <div class="space-y-0">
            @for (row of selectedTab.rows; track row.label; let isLast = $last) {
              <div
                class="flex flex-col gap-2.5 border-b border-dashed border-gray-200 py-3.5 sm:flex-row sm:items-center sm:justify-between sm:gap-6 sm:py-4"
                [class.border-b-0]="isLast && !selectedTab.footer">
                <p
                  class="font-normal leading-snug text-gray-700 font-['Inter']"
                  [ngClass]="selectedTab.id === 'validacao-riscos' ? 'text-sm sm:text-base' : 'text-base sm:text-lg'">
                  {{ row.label }}
                </p>
                <p
                  class="font-semibold leading-snug font-['Inter'] sm:text-right"
                  [class.rounded-xl]="row.valueBadge && selectedTab.id !== 'validacao-riscos'"
                  [class.rounded-lg]="row.valueBadge && selectedTab.id === 'validacao-riscos'"
                  [class.px-4]="row.valueBadge && selectedTab.id !== 'validacao-riscos'"
                  [class.py-2]="row.valueBadge && selectedTab.id !== 'validacao-riscos'"
                  [class.px-3]="row.valueBadge && selectedTab.id === 'validacao-riscos'"
                  [class.py-1]="row.valueBadge && selectedTab.id === 'validacao-riscos'"
                  [class.inline-flex]="row.valueBadge"
                  [class.items-center]="row.valueBadge"
                  [class.justify-center]="row.valueBadge"
                  [class.self-start]="row.valueBadge"
                  [class.sm:self-auto]="row.valueBadge"
                  [ngClass]="selectedTab.id === 'validacao-riscos' ? 'text-sm sm:text-base' : 'text-base sm:text-lg'"
                  [class]="getValueClasses(row)">
                  {{ row.value }}
                </p>
              </div>
            }
          </div>

          @if (selectedTab.footer) {
            <p class="border-t border-gray-200 pt-5 text-sm font-normal leading-relaxed text-gray-500 font-['Inter'] sm:pt-6 sm:text-base">
              {{ selectedTab.footer }}
            </p>
          }
        </section>
      </div>
    </div>
  </div>
</section>
